<div class="popup-global-layout p-4 p-md-5">
    <div class="d-flex justify-content-end"><mat-icon class="icon" (click)="close()">close</mat-icon></div>
    <div class="global-title">Summary of Terms &amp; Conditions</div>
    <div class="global-green-bar"></div>
    <div class="global-text">
        
        <div>
            <div class="modal-body">
            <div class="scroll-area">
            

              <ol>
                <li><strong class="underline">Summary of Coverage:</strong> The FMC policy protects insured packages against loss of or physical damage to contents.  You, and only you, will be the Named Insured on the FMC policy issued to you.  No other party will be named as a Named Insured or Additional Insured on the FMC policy, and as such, no other party will have policyholder rights or any rights to make claims under the FMC policy.  All claims payments under the FMC policy will be made directly to you.  No claim will be denied for insufficient or inadequate packing in any case where you packed or prepared the subject package for shipment (i.e., the package was “Center Packed” and was identified as such in the “Packed by” section of the iShip system) using non-carrier provided packaging (i.e., the package was packed using packaging materials purchased from you as indicated by your selection of “Other Packaging” in the Package Type section of the iShip system).</li>
                <li><strong class="underline">Effective Date:</strong> If you sign up for FMC at the 2016 The UPS Store Convention, your FMC policy will become effective on September 12, 2016.  If you sign up for coverage after the Convention, your FMC policy will become effective within 10 days. You will be notified of your actual policy start date in your “Welcome Kit” e-mail.</li>
                <li><strong class="underline">Maximum Insured Value (per package):</strong> $10,000 except for (i) packages containing laptops, cellular/mobile phones or tablets, which packages are subject to a Maximum Insured Value of $5,000, and (ii) packages containing jewelry, which packages are subject to a Maximum Insured Value of $1,000.</li>
                <li><strong class="underline">Deductible Amount (per package):</strong> $0 for USPS packages; $0 for DHL packages</li>
                <li><strong class="underline">Excluded Commodities:</strong> Your policy will not cover the following commodities: coins, currency, postage stamps, negotiable instruments (except checks), money orders, unset precious stones, industrial diamonds, any article that contains more than fifty percent by weight of gold or platinum or any combination thereof in raw form, including, but not limited to, bullion, bars, or scraps of these metals, or any other restricted items or commodities pursuant to the terms and conditions of the applicable Approved Transportation Provider.</li>
                <li style="overflow: hidden;"><strong class="underline">Flexible Parcel Multi-Carrier Insurance Premiums:</strong>

                  <table class="table table-tupss table-responsive table-bordered tupss-domestic">
                   <thead>
                    <tr>
                      <td class="td-blank"></td>
                      <td colspan="4">Insured Value in ($) US Dollars</td>
                      <td class="td-blank"></td>
                    </tr>
                    <tr>
                      <th>USPS - Domestic</th>
                      <th>.01 - 50</th>
                      <th>50.01 - 100</th>
                      <th>100.01 - 200</th>
                      <th>200.01 - 300<br>(base)</th>
                      <th>Rate per $100<br>300.01 - 10,000<br>(plus base)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Center Packed</td>
                      <td>0.70</td>
                      <td>0.75</td>
                      <td>1.55</td>
                      <td>2.35</td>
                      <td>0.70</td>
                    </tr>
                    <tr>
                      <td>Customer Packed</td>
                      <td>0.75</td>
                      <td>0.80</td>
                      <td>1.60</td>
                      <td>2.40</td>
                      <td>0.75</td>
                    </tr>
                  </tbody>
                  </table>

                 
                    <table class="table table-tupss table-responsive table-bordered tupss-international">
                     <thead>
                      <tr>
                        <th>USPS - International</th>
                        <th>Rate per $100<br>.01 - 10,000</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Center Packed</td>
                        <td>1.30</td>
                      </tr>
                      <tr>
                        <td>Customer Packed</td>
                        <td>1.35</td>
                      </tr>
                    </tbody>
                    </table>

                    <table class="table table-tupss table-responsive table-bordered tupss-dhl">
                     <thead>
                      <tr>
                        <th>DHL</th>
                        <th>Rate per $100<br>.01 - 10,000</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Center Packed</td>
                        <td>0.60</td>
                      </tr>
                      <tr>
                        <td>Customer Packed</td>
                        <td>0.65</td>
                      </tr>
                    </tbody>
                    </table>
                  

                </li>
                <li><strong class="underline">Valuation:</strong> Goods and/or merchandise and/or property insured shall be valued at: selling price if pre-sold, replacement cost if unsold.</li>
                <li><strong class="underline">No Insurance Mark-Up.</strong> As a condition to the issuance of your FMC policy and in order for any coverage under the policy to attach to a shipment, you agree to not "mark up" the cost of insurance or otherwise receive any compensation/commissions tied to the sale or profitability of insurance.</li>
                <li><strong class="underline">Retail Customer Disclosures:</strong> As a condition to the issuance of your FMC policy and in order for any coverage under the policy to attach to a shipment, you agree to (i) provide any required disclosure statements furnished to you by The UPS Store, Inc. and/or UPSCIA to your customers who elect to protect their packages under your FMC Policy at the point of sale, (ii) obtain the written acknowledgement of such customers on any such disclosure statements at the point of sale, as may be instructed by The UPS Store, Inc. and/or UPSCIA, and (iii) retain and furnish to The UPS Store, Inc. and/or UPSCIA upon request copies of all such customer acknowledgements received by you from time to time.  </li>
              </ol>

              <p><strong>This is intended only to provide a brief summary of the FMC policy.  The FMC policy issued to you will contain the complete terms, conditions, limitations and exclusions relating thereto.  Please review the policy in its entirety upon delivery.  UPSCIA reserves the right to modify or withdraw this proposal at any time.</strong></p>

              <p>UPSCIA and its licensed affiliates may receive a commission from an insurer or other intermediary and/or additional compensation in connection with the sale of this insurance to you.  If you have any additional questions, please contact UPSCIA at 866-202-2511. </p>

            </div>
          </div>

        </div>
        
    </div>
  </div>